import "babel-polyfill";
// import "./libs/jcf/jcf.js";
// import "./libs/jcf/jcf.scrollable.js";
// import "./libs/jcf/jcf.select.js";
import "./libs/slick";
// import "./libs/jquery-ui";
import "./libs/jquery.fancybox";     // lazyloaded, 2023-01-05
import "./libs/sweetalert.min";
import "./libs/daterangepicker";
import { binder } from "./libs/binder";
import {
    constants,
    navFunction,
    stickyHeader,
    footerMenu,
    fancyButtonFix
} from "./modules/module";
import { upcomingEventsSlider } from "./modules/upcomingEventsSlider";
import { faq } from "./modules/faq";
import { locations } from "./modules/locations";
import { bikeCarousel } from "./modules/bikeCarousel";
import { toursCarousel } from "./modules/toursCarousel";
import { googleMap } from "./modules/googleMap";
import { bikeToursSlider } from "./modules/bikeToursSlider";
import { resetFilterForm } from "./modules/resetFilterForm";
import { datepicker } from "./modules/datepicker";
import { daterangePicker } from "./modules/daterangePicker";
import { events } from "./modules/events";
import { eventDetail } from "./modules/eventDetail";
import { eventListing } from "./modules/eventListing";
import { tourDetailSlider } from "./modules/tourDetailSlider";
import { tourCategoryListing } from "./modules/tourCategoryListing";
import { rentalDetail } from "./modules/rentalDetail";
import { bikeDetail } from "./modules/bikeDetail";
import { attractionDetail } from "./modules/attractionDetail";
import { groupDetail } from "./modules/groupDetail";
import { homePage } from "./modules/home";
import { initializeLiveChat } from "./modules/live-chat";
import { contactForms } from "./modules/forms";

window.moment = require('moment');

binder({
    bounds: {
        "html": [constants],
        "body": [contactForms, fancyButtonFix],
        ".header": [navFunction, stickyHeader],
        ".footer": [initializeLiveChat, footerMenu],
        // "select": customSelect,
        ".upcoming-events-slider": upcomingEventsSlider,
        ".faq-holder": faq,
        ".locations": locations,
        ".bike-carousel": bikeCarousel,
        ".tours-carousel": toursCarousel,
        ".map": googleMap,
        ".bike-tours-slider": bikeToursSlider,
        ".tour-detail-page": tourDetailSlider,
        ".filter-form": resetFilterForm,
        // ".datepicker": datepicker,
        ".daterange-picker": daterangePicker,
        ".events-info": events,
        ".event-listing-page": eventListing,
        ".event-detail-page": eventDetail,
        ".tour-listing-page": tourCategoryListing,
        ".rich-homepage-wrapper": homePage,
        ".rental-detail-page": rentalDetail,
        ".group-detail-page": groupDetail,
        ".bike-detail-page": bikeDetail,
        ".attraction-detail-page": attractionDetail,
    },
    runTests: false
});


// WEBPACK FOOTER //
// ./c:/Projects/UB/unlimitedbiking.com/wp-content/themes/unlimitedbiking/slice/assets/js/global.js